// src/app/core/interceptors/error.interceptor.ts
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../authentication/authentication.service';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthenticationService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'An unknown error occurred!';
      console.error('ErrorInterceptor caught error:', error);

      if (error.error instanceof ErrorEvent) {
        errorMessage = `Network error: ${error.error.message}`;
      } else {
        switch (error.status) {
          case 401:
            errorMessage = 'Unauthorized: Please log in again.';
            authService.clearAllCookies();
            router.navigate(['/login']);
            break;
          case 403:
            errorMessage = 'Forbidden: Access denied.';
            break;
          case 404:
            errorMessage = 'Error 404: Not Found.';
            break;
          case 409:
            errorMessage = error.error?.message || 'Conflict error occurred.';
            break;
          case 500:
          case 503:
            errorMessage = `Server error (${error.status}): Try again later.`;
            break;
          default:
            if (error.error?.message) {
              errorMessage = `Error ${error.status}: ${error.error.message}`;
            } else if (typeof error.error === 'string') {
              errorMessage = `Error ${error.status}: ${error.error}`;
            } else {
              errorMessage = `Unexpected Error (${error.status}): ${error.message}`;
            }
        }
      }

      return throwError(() => new Error(error.error.message));
    })
  );
};
